import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export interface Rating {
  id: number;
  creationDate: string;
  userId: number;
  poiId: number;
  stars: number;
  text: string;
  username: string;
}

@Injectable({
  providedIn: 'root'
})
export class RatingService {

  constructor(private http: HttpClient) { }

  loadRatings(poiId: number) {
    // console.log(environment.baseUrl + environment.endpoints.ratings + '/' + poiId)
    return this.http.get<Rating[]>(environment.baseUrl + environment.endpoints.ratings + '/' + poiId);
  }
}
